import { render, staticRenderFns } from "./PortalStatusPill.vue?vue&type=template&id=963ee2f2&scoped=true&"
import script from "./PortalStatusPill.vue?vue&type=script&lang=js&"
export * from "./PortalStatusPill.vue?vue&type=script&lang=js&"
import style0 from "./PortalStatusPill.vue?vue&type=style&index=0&id=963ee2f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963ee2f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('963ee2f2')) {
      api.createRecord('963ee2f2', component.options)
    } else {
      api.reload('963ee2f2', component.options)
    }
    module.hot.accept("./PortalStatusPill.vue?vue&type=template&id=963ee2f2&scoped=true&", function () {
      api.rerender('963ee2f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PortalStatusPill.vue"
export default component.exports